/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { OasSecurityRequirement } from '../../models/OasSecurityRequirement';

/**
 * @author eric.wittmann@gmail.com
 * @class
 * @extends OasSecurityRequirement
 */
export class Oas30SecurityRequirement extends OasSecurityRequirement {
    constructor() {
        super();
    }
}
Oas30SecurityRequirement["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30SecurityRequirement";
Oas30SecurityRequirement["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




